import QuestionData from '../assets/data/faq.json';

interface iFAQ {
  question: string;
  message: string;
}

export function Faqs() {
  const faqs = (): iFAQ[][] => {
    const columnsCount = 3;
    const q: iFAQ[][] = Array.from(
      { length: columnsCount },
      () => []
    );
    const shuffled = QuestionData.sort();
    const shortlist = shuffled.slice(0, 6);

    shortlist.forEach(
      (question: { question: string; message: string }, index) => {
        const columnIndex = index % columnsCount;
        q[columnIndex].push(question);
      }
    );
    return q;
  };

  return (
    <section
      id="faqs"
      aria-labelledby="faqs-title"
      className="border-t border-gray-200 py-20 sm:py-32 bg-lightblue"
    >
      <div className="container">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2
            id="faqs-title"
            className="text-3xl font-medium tracking-tight text-gray-900"
          >
            Frequently asked questions
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Have more questions?{' '}
            <a
              href="/faq"
              className="text-gray-900 underline cursor-pointer"
            >
              See the full FAQ
            </a>
            .
          </p>
        </div>
        <ul className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 lg:max-w-none lg:grid-cols-3">
          {faqs().map((column, columnIndex) => (
            <li key={columnIndex}>
              <ul className="space-y-10">
                {column.map((faq, faqIndex) => (
                  <li key={faqIndex}>
                    <h3 className="text-lg font-semibold leading-6 text-gray-900">
                      {faq.question}
                    </h3>
                    <p className="mt-4 text-md text-gray-700">
                      {faq.message}
                    </p>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
